import { AxiosStatic, AxiosPromise } from 'axios';
import { SpecialSituationMessage, Version } from '../models/api-client';

class HomeService {
  public controllerUri: string;

  constructor(public axios: AxiosStatic, public baseUrl: string) {
    this.axios = axios;
    this.baseUrl = baseUrl;
    this.controllerUri = 'Home';
  }

  getVersions(): AxiosPromise<Version> {
    return this.axios.get(`${this.baseUrl + this.controllerUri}/GetVersions/`);
  }
  
  getMessage(): AxiosPromise<SpecialSituationMessage> {
    return this.axios.get(`${this.baseUrl + this.controllerUri}/GetMessage/`);
  }
}

export default HomeService;
